/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Cargos_Unarchived_CountInputs */

const en_cargos_unarchived_count = /** @type {(inputs: Cargos_Unarchived_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unarchived ${i?.count} cargos`)
};

const es_cargos_unarchived_count = /** @type {(inputs: Cargos_Unarchived_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se desarchivaron ${i?.count} cargas`)
};

/**
* | output |
* | --- |
* | "Unarchived {count} cargos" |
*
* @param {Cargos_Unarchived_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_unarchived_count = /** @type {((inputs: Cargos_Unarchived_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Unarchived_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_unarchived_count(inputs)
	return es_cargos_unarchived_count(inputs)
});